import * as actionTypes from "./CustomerTypes";

const INITIAL_STATE = {
    currencyList: [],
    industryList: [],
    customerGroupList: [],
    salesEmployeeList: [],
    stateList: [],
    countryList: [],
    seriesList: []
};

const CustomerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETCUSTOMERGROUPLIST:
            return {
                ...state,
                customerGroupList: action.payload.list,
            };
        case actionTypes.SETINDUSTRYLIST:
            return {
                ...state,
                industryList: action.payload.list,
            };
        case actionTypes.SETEMPLIST:
            return {
                ...state,
                salesEmployeeList: action.payload.list,
            };
        case actionTypes.SETCURRENCYLIST:
            return {
                ...state,
                currencyList: action.payload.list,
            };
        case actionTypes.SETSTATELIST:
            return {
                ...state,
                stateList: action.payload.list,
            };
        case actionTypes.SETCOUNTRYLIST:
            return {
                ...state,
                countryList: action.payload.list,
            };
        case actionTypes.SETSERIESLIST:
            return {
                ...state,
                seriesList: action.payload.list,
            };
        default:
            return state;
    }
}

export default CustomerReducer;